module.exports = __webpack_public_path__ + "img/spinner-3.c0c00338.gif";